import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@/consts';
import { CAMPAIGN_CFG } from '@/configs/campaign-config';
import { contestRepository, WeeklyContestData } from '@/repositories/contest-repository';

export const useWeeklyContest = () =>
	useQuery<WeeklyContestData>({
		queryKey: [QueryKeys.WeeklyContest],
		queryFn: ({ signal }) => contestRepository.getWeeklyContest(signal),
		staleTime: 30_000,
		refetchInterval: 60_000,
		enabled: CAMPAIGN_CFG.features.weeklyRace.visible !== false,
	});
